<template>
    <div class="modal-card">
                    <section class="modal-card-body">
                        <SearchOPDForGeneral @HNSelected="HNSelected" />
                    </section>
                    <footer class="modal-card-foot"  >
                        <b-button type="is-danger" @click="close">Close</b-button>                        
                    </footer>
                </div>
</template>

<script>
import SearchOPDForGeneral from '../../UtilsComponents/SearchOPDForGeneral.vue'

export default {
    name : "SearchOPDForPrepareMakeInvoice",
    created() {
            const unregisterRouterGuard = this.$router.beforeEach((to, from, next) => {
                this.close()
                next(false)
            })

            this.$once('hook:destroyed', () => {
                unregisterRouterGuard()
            })
    },
    components:{
        SearchOPDForGeneral ,
    },
    methods:{
        close(){
           this.$emit('close') 
        },
        HNSelected(_data){
             this.$emit('HNSelected',_data)
        }
    }
}
</script>